import React, { useEffect } from 'react';
import MailGo from 'mailgo';
// eslint-disable-next-line import/no-cycle
import * as S from './Socials.styled';
// eslint-disable-next-line import/no-cycle
import { Tooltip } from '../index';
import { SocialsList } from './SocialsList';
import { ensureBackgroundForForeground } from '~/modules/Helper/contrast.helper';

/**
 * mailgo injeta #mailgo / #mailgo-tel no body.
 * Só define aria-hidden="true" quando ainda não está definido —
 * NÃO reaplicar se já for "true" (evita loop infinito no MutationObserver/Firefox).
 */
function ensureClosedMailgoHidden() {
  ['mailgo', 'mailgo-tel'].forEach(id => {
    const el = document.getElementById(id);
    if (!el) return;
    const hidden = el.getAttribute('aria-hidden');
    // Aberto pelo mailgo
    if (hidden === 'false') return;
    // Já marcado — não setAttribute de novo (dispara observer em loop)
    if (hidden === 'true') return;
    el.setAttribute('aria-hidden', 'true');
  });
}

export default function Socials() {
  useEffect(() => {
    MailGo();
    ensureClosedMailgoHidden();

    // Só childList no body — quando o mailgo injeta os nós.
    // Sem observar aria-hidden (causava loop: set → mutate → set → …).
    const observer = new MutationObserver(mutations => {
      const added = mutations.some(
        m => m.type === 'childList' && m.addedNodes && m.addedNodes.length > 0
      );
      if (added) {
        ensureClosedMailgoHidden();
      }
    });

    observer.observe(document.body, { childList: true });

    // mailgo pode injetar após o primeiro tick
    const t1 = window.setTimeout(ensureClosedMailgoHidden, 0);
    const t2 = window.setTimeout(ensureClosedMailgoHidden, 500);

    return () => {
      observer.disconnect();
      window.clearTimeout(t1);
      window.clearTimeout(t2);
    };
  }, []);

  return (
    <S.SocialsContainer as="aside" aria-label="Redes sociais">
      {SocialsList &&
        SocialsList().map(
          item =>
            item.link && (
              <Tooltip key={item.ToolTip} title={item.ToolTip} placement="leftTop">
                <S.ButtonStyled
                  href={item?.mail ? item.link : null}
                  onClick={
                    !item.mail ? () => window.open(item.link, '_blank') : null
                  }
                  background={ensureBackgroundForForeground(
                    item?.background || '#595959'
                  )}
                  type="primary"
                  color="#fff"
                  icon={item?.icon}
                  aria-label={item.ToolTip}
                />
              </Tooltip>
            )
        )}
    </S.SocialsContainer>
  );
}
